import styled, { css } from 'styled-components';

import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { scale130, scale190 } from '@xing-com/tokens';

const baseStyles = css`
  max-width: 948px;
  margin: 0 auto;
`;

export const NativeAdTopContainer = styled.div`
  ${baseStyles}

  margin-bottom: ${scale190};
  @media ${mediaSmallOrTiny} {
      margin-bottom: 0;
    }
`;

export const NativeAdBottomContainer = styled.div`
  ${baseStyles}

  margin-top: ${scale130};
  margin-bottom: ${scale130};
  @media ${mediaConfined} {
    margin-top: ${scale190};
    margin-bottom: 0;
  }
`;
